export default [
  {
    path: '/admin/site/list',
    name: 'siteList',
    component: () => import('@/views/admin/site/list.vue'),
    meta: { title: '站点列表', requireAuth: true }
  }
]
